export enum AccountTPBankQueryKeys {
  GET_TRANSACTIONS = 'GET_TRANSACTIONS',
}
